$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  createBurgerIcon();
  customSearchBar();
  changeWeatherFormat();
  editSignupForm();
  updateSponsorTitleTag();
});

// --------------------------------
// Helpers
// Custom burger menu
function createBurgerIcon() {
  $.each(new Array(3), function () {
    $('.header .mobile-nav-toggle').append('<div></div>');
  });
}

// Searchbox scripts
function customSearchBar() {
  let searchPlaceholder = 'Search Website';
  const $headerSearchInput = $('.header .searchBox input');

  $headerSearchInput.val('');
  $headerSearchInput.attr('placeholder', searchPlaceholder);
}

// Function for weather format

function changeWeatherFormat() {
  setInterval(function () {
    let str = $('#weatherBugDescription').text();
    let weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (weatherBugSet || str == '') return;
    $('#weatherBugWidget').addClass('weatherBugSet');
    let findSpace = str.lastIndexOf(' ');
    let stringLength = str.length;
    let res = str.substring(findSpace, stringLength);
    let start = str.substring(0, findSpace);
    $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
    $('#weatherBugWidget').css('opacity', 1);
  }, 1000);
}

// Function to edit signup elements

function editSignupForm() {
  const $signupForm = $('.tier-3-container .signup-wraper .emailSignup');
  $signupForm.find('.emailSignupText').remove();
  $signupForm.find('.emailInputField input').val('');
  $signupForm.find('.emailInputField input').attr('placeholder', 'Enter Email');

  $signupForm.find('.emailInputSubmit .button').text('Sign Up');
  $signupForm.closest('.signup-wraper').append('<div class="signup-abstract"></div>');
}

// Function to change tag on sponsors
function updateSponsorTitleTag() {
  $(window).load(function () {
    const sponsorsTitle = $('.homepageh1').text();
    $('.homepageh1').replaceWith(`<h2 class="homepageh1">${sponsorsTitle}</h2>`);
  });
}
